export const SINGLETON_KEY = "singleton_key" as const;
export const PREFIX = "miaparle" as const;
